var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoUltradentSymbol = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.486 0c1.51 0 3.043 1.618 3.043 3.203l.016 10.83c0 .814-.67 1.472-1.498 1.472l-10.133-.004c-.811-.017-1.479-.666-1.479-1.467V10.38c0-.788.652-1.467 1.462-1.467h3.035c.655 0 1.183-.542 1.143-1.195-.037-.601-.575-1.056-1.188-1.056h-4.953c-.883 0-1.6.703-1.6 1.57V20.76c0 1.617-1.532 3.24-3.041 3.24H3.012C1.503 24-.004 22.377 0 20.76.004 19.635 0 1.333 0 1.333 0 .603.603.01 1.346.01H11.75c.743 0 1.346.592 1.346 1.322v11.822c0 .623.551 1.12 1.201 1.045.546-.064.941-.55.941-1.09V1.335c0-.73.603-1.322 1.347-1.322 0 0 20.707-.012 23.902-.012Zm3.043 22.527.003-3.445c0-.813-.67-1.471-1.498-1.47H31.875c-.811.019-1.464.67-1.464 1.472v3.445c0 .8.653 1.448 1.464 1.467l10.156.003c.828 0 1.498-.659 1.498-1.471Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoUltradentSymbol);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-ultradent-symbol.c40c6fccf0de78dec9e1d2c45220b840.svg";